( function( $, window ) {
	'use strict';

	$( function() {
		const pagerFix = () => {
			const $pager = $( '.facetwp-pager' );

			if ( !$pager.length )
				return;

			$pager.parent().removeClass( 'hidden' );
			if ( !$pager.children().length ) {
				$pager.parent().addClass( 'hidden' );
				return;
			}

			if ( !$pager.find( '.facetwp-page.prev' ).length ) {
				$pager.prepend( '<a class="facetwp-page prev is-disabled"><svg class="facetwp-page__icon icon icon--arrow-prev" role="img" focusable="false"><use xlink:href="#svg-arrow-prev"></use></svg><span class="u-visually-hidden">Previous</span></a>' );
				return;
			}

			if ( !$pager.find( '.facetwp-page.next' ).length ) {
				$pager.append( '<a class="facetwp-page next is-disabled"><svg class="facetwp-page__icon icon icon--arrow-next" role="img" focusable="false"><use xlink:href="#svg-arrow-next"></use></svg><span class="u-visually-hidden">Next</span></a>' );
				return;
			}
		};

		$( document ).on( 'facetwp-loaded', function() {
			pagerFix();
		} );
	} );
} )( jQuery, window );
